<template>
  <form class='schedule-flow__login' data-vv-scope='flowLogin'>
    <h2 class='section-title'>{{locales.appointments && locales.appointments.schedule_viewing}}</h2>
    <h3 class='schedule-flow__step-title'>{{locales.common && locales.common.login}}</h3>
    <div class='grid grid-cols-1 md:grid-cols-2 gap-4 mb-10'>
      <theme-input
        :label='locales.common && locales.common.email'
        :value='email'
        :placeholder='locales.common && locales.common.enter_your_email'
        name='email'
        v-validate='`required`'
        valid-scope="flowLogin"
        @change='updateEmail'
      />
      <theme-input
        :value='password'
        :label='locales.common && locales.common.password'
        :placeholder='locales.common && locales.common.enter_your_password'
        type="password"
        name='password'
        v-validate='`required`'
        valid-scope="flowLogin"
        @change='updatePassword'
      />
    </div>
    <div class='mb-5'>
      <a href='#' class='theme-btn theme-btn--theme' :class="{'theme-btn--theme-disabled': validated && this.errors.any()}" @click.prevent='login'>{{locales.common && locales.common.continue}}</a>
    </div>
    <a :href='accountCreateLink' class='theme-btn theme-btn--tertiary'>
      {{ locales.common && locales.common.i_dont_have_account_yet }}
      <i class='icon-go-right'/>
    </a>
  </form>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      accountCreateLink: {
        default: '',
        type: String,
      },
    },
    data() {
      return {
        validated: false,
        email: '',
        password: ''
      };
    },
    computed: {
      ...mapGetters(['locales']),
    },
    methods: {
      updateEmail(event) {
        this.email = event.target.value;
      },
      updatePassword(event) {
        this.password = event.target.value;
      },
      login() {
        this.$validator.validateAll('flowLogin').then((valid) => {
          this.validated = true;
          if (valid) {
            this.$store.dispatch('authLogin', {email: this.email, password: this.password});
          }
        });
      },
    },
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/ScheduleFlowLogin.vue